import React, { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { postData, getData } from '../Services/api'

const RouteAdd = () => {
  const [users, setUsers] = useState([]);
  const [values, setValues] = useState({ route_name: "", user_ids: [] })
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // fetch salespersons
  const fetchUsers = async () => {
    try {
      const res = await getData(`/users/salesperson-admin`);
      if (res.success) {
        setUsers(res.data || [])
      }
    } catch (error) {
      console.log("error fetch users", error)
    }
  }

  useEffect(() => {
    fetchUsers();
  }, [])

  // handle text field
  const handleChange = (e) => {
    const { name, value } = e.target;
    setValues({ ...values, [name]: value });
  }

  // handle checkbox change
  const handleUserCheckbox = (id) => {
    let updatedIds = [...values.user_ids];
    if (updatedIds.includes(id.toString())) {
      updatedIds = updatedIds.filter(uid => uid !== id.toString());
    } else {
      updatedIds.push(id.toString());
    }
    setValues({ ...values, user_ids: updatedIds });
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      // create route + update users in one request
      const res = await postData('/routes/create', values);
      if (res.status) {
        toast.success(res.message || 'Route created successfully');
        navigate('/routes/route-list');
        setValues({ route_name: "", user_ids: [] });
      } else {
        toast.error(res.message);
      }
    } catch (error) {
      console.log("error route adding", error)
      toast.error(error.response?.data?.message || 'error')
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      <div className="pc-container">
        <div className="pc-content">
          <div className="page-header">
            <div className="page-block">
              <div className="row align-items-center">
                <div className="col-md-12">
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/">Home</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/routes/route-list">Routes</Link>
                    </li>
                    <li className="breadcrumb-item" aria-current="page">
                      Add Route
                    </li>
                  </ul>
                </div>
                <div className="col-md-12">
                  <div className="page-header-title">
                    <h2 className="mb-0">Add Route</h2>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-header">
                  <h5>Add Route</h5>
                </div>
                <div className="card-body">
                  <form onSubmit={handleSubmit}>
                    <div className="row">
                      <div className="col-md-12">
                        <div className="form-group">
                          <label className="form-label">Route Name</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter route name"
                            name='route_name'
                            value={values.route_name}
                            onChange={handleChange}
                            required
                          />
                        </div>
                      </div>

                      {/* ✅ Checkbox list for salespersons */}
                      <div className="col-md-12 mt-3">
                        <label className="form-label">Assign Salespersons</label>
                        <ul className="list-group">
                          {users.map(user => (
                            <li key={user.id} className="list-group-item d-flex align-items-center">
                              <input
                                type="checkbox"
                                className="form-check-input me-2"
                                checked={values.user_ids.includes(user.id.toString())}
                                onChange={() => handleUserCheckbox(user.id)}
                              />
                              <span>{user.username} ({user.email})</span>
                            </li>
                          ))}
                        </ul>
                      </div>

                      <div className="text-end btn-page mb-0 mt-4">
                        <Link to="/routes/route-list" className="btn btn-outline-secondary">Cancel</Link>
                        <button className="btn btn-primary" type="submit" disabled={loading}>
                          {loading ? 'Saving...' : 'Save'}
                        </button>
                      </div>
                    </div>
                  </form >
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </>
  )
}

export default RouteAdd
